<template>
  <div class="row">
    <panel class="col-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
      <w-input :model="$schema.name" />

      <w-input :model="$schema.schoolYear" />

      <w-vue-select :model="$schema.procedureId" :values="procedureList" :searchable="true" />

      <div slot="footer" class="text-right">
        <w-button class="btn-primary" text="Utwórz procedurę" @click="copyProcedure" />
      </div>
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/procedureCopy.schema';
import { tryParseInt } from '@/utils/number';

// @vuese
// Tworzenie procedury na podstawie już istniejącej
// @group Procedure
export default {
  schema,
  components: { Panel },
  mixins: [formMixin],
  data() {
    return {
      model: {}
    };
  },
  computed: {
    ...mapState({
      procedureList: state => state.procedure.list.map(procedure => ({ text: procedure.name, value: procedure.id }))
    })
  },
  methods: {
    // @vuese
    // Utwórz procedurę na podstawie już istniejacej
    copyProcedure() {
      if (this.$schema.$validateAll().length !== 0) {
        return;
      }
      this.$store
        .dispatch('procedure/copy', { ...this.$schema.$model })
        .then(newProcedureId =>
          this.$router.push({ name: 'procedureDetails', params: { procedureId: newProcedureId } })
        )
        .catch(err => this.$store.dispatch('notifyError', { title: Errors.PROCEDURE_CANNOT_CREATE }));
    }
  }
};
</script>
